<template>
    <div>
        <div>
            <div>
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    URL
                </label>
                <input type="text" class="form-control " @input="onChange($event)"
                    :value="url" />
            </div>
            <div class="mt-3">
                <div class="border rounded py-2 px-3">
                    <div class="d-flex align-items-center justify-content-between">
                        <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                            background Color
                        </label>

                        <input type="color" @input="onBgchange($event)" name="backgroundColor" class="custonInput"
                            :value="bgColor" />
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <div class="border rounded py-2 px-3">
                    <div class="d-flex align-items-center justify-content-between">
                        <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                             Color
                        </label>

                        <input type="color" @input="onColorChange($event)" name="backgroundColor" class="custonInput"
                            :value="lineColor" />
                    </div>
                </div>
            </div>
            <div class=" mt-3">
            <div class="d-flex align-items-center justify-content-between">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    Transparent Background
                </label>
                <Switches theme="bootstrap" v-model="tBG" color="success" ></Switches>
            </div> 
        </div>
        </div>
    </div>
</template>
<script>
import Switches from 'vue-switches';
export default {
    name: "qrCodeAppSettings",
     components:{
        Switches,
     },
    data() {
        return {
            url:"",
            bgColor:"",
            lineColor:"",
            tBG:true,
        }
    },
    computed:{
        getActiveCanvasObjProps(){
            return this.$store.getters.getActiveObjectprops
        },
    },
    watch:{
        getActiveCanvasObjProps :{
          handler(updatedValues) {
            
           
            this.url = updatedValues.url;
            this.bgColor = updatedValues.bgColor;
            this.lineColor = updatedValues.lineColor;

            },
            deep: true,
            immediate: true
        },
        tBG(value){
        this.changeTransparentBackground(value)
    }
    },
    methods: {
        onChange(e) {
            debugger // eslint-disable-line no-debugger
            let value = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties", { url: value });
        },
        onBgchange(e){
            let value = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties", { bgColor: value });
        },
        onColorChange(e){
            let value = e.target.value;

            this.$store.dispatch("setCurrentObjectProperties", { lineColor: value });
        },
        changeTransparentBackground(value){
        this.$store.dispatch("setCurrentObjectProperties", { transparentBG: value });
        },
    }

}
</script>